import { useState, useCallback } from 'react'
import URI from 'urijs'

/**
 * Get search value
 *
 * @param {string} key
 * @param {string} href
 */
const getSeachValue = (key, href = window.location.href) => {
  const uri = new URI(href)
  const values = uri.search(true) // true makes it return an object
  return values[key]
}

/**
 * Set search value without reloading the page
 *
 * @param {string} key
 * @param {string} value
 * @param {string} href
 */
const setSearchValue = (key, value, href = window.location.href) => {
  const uri = new URI(href)
  uri.setSearch(key, value)
  const url = uri.toString()
  // eslint-disable-next-line no-restricted-syntax
  window.history.pushState({ path: url }, '', url)
}

/**
 * useQueryString hook
 *
 * @param {string} key
 * @param {string} initialValue
 */
const useQueryString = (key, initialValue = '') => {
  const [value, setValue] = useState(getSeachValue(key) || initialValue)
  const onSetValue = useCallback(
    (newValue) => {
      setValue(newValue)
      setSearchValue(key, newValue)
    },
    [key]
  )
  return [value, onSetValue]
}

export default useQueryString
